import {IDischargeModel, IStation, IAggregationsData} from '../../api/api.types';
import {
    IStationApi,
    IStationDetailsRequest
} from '../../api/station-api.service';
import {IStationDetails} from '../details/edit.controller';
import {StateService} from 'angular-ui-router';
import {IImomoErrorService} from '../../error/error.service';
import IUploadService = angular.angularFileUpload.IUploadService;

export default class StationCreatorController {
  static $inject = ['$state', 'stationApi', 'imomoErrorService', 'Upload', '$mdDialog', '$translate'];

  selectedTabIndex:number;
  stationDetails:IStationDetails;
  dischargeModel:IDischargeModel;
  aggregations: any;
  historicalDataFile:File;
  snowDataFile: File;
  isLoading:boolean;
  isVirtual: boolean;

  private isStepOneValid:boolean;
  private isStepTwoValid:boolean;
  private isStepThreeValid:boolean;
  private isStepFourValid:boolean;

  constructor(
    private $state:StateService, 
    private stationApi:IStationApi,
    private imomoErrorService: IImomoErrorService,
    private Upload:IUploadService,
    private $mdDialog: ng.material.IDialogService,
    private $translate:ng.translate.ITranslateService) {}

  $onInit() {
    this.isStepOneValid = false;
    this.isStepTwoValid = false;
    this.isStepThreeValid = false;
    this.isStepFourValid = false;

    this.isVirtual = this.$state.current.name === 'station.creatorVirtual';
  }

  get isStepTwoDisabled() {
    return !this.isStepOneValid;
  }

  get isStepThreeDisabled() {
    return !this.isStepOneValid || !this.isStepTwoValid;
  }

  get isStepFourDisabled() {
    return !this.isStepOneValid || !this.isStepTwoValid;
  }

  get isStepFiveDisabled() {
    return !this.isStepOneValid || !this.isStepTwoValid;
  }

  get isNextButtonDisabled() {
    switch (this.selectedTabIndex) {
      case 0:
        return this.isStepTwoDisabled;
      case 1:
        return this.isStepThreeDisabled;
      case 2:
        return this.isStepFourDisabled;
      case 3:
        return this.isStepFiveDisabled;
      default:
        return true;
    }
  }

  get isPrevButtonDisabled() {
    switch (this.selectedTabIndex) {
      case 0:
        return true;
      default:
        return false;
    }
  }

  get isSubmitButtonDisabled() {
    if(this.isVirtual) {
      return !this.isStepOneValid
          || !this.isStepTwoValid
          || this.isLoading;
    } else {
      return !this.isStepOneValid
          || !this.isStepTwoValid
          || this.isLoading;
    }
    
  }

  get isLastStep() {
    if(this.isVirtual) {
      return this.selectedTabIndex == 1;
    } else {
      return this.selectedTabIndex == 3;
    }
  }

  onDischargeModelChange(dischargeModel:IDischargeModel, isValid:boolean) {
    this.dischargeModel = dischargeModel;
    this.isStepTwoValid = isValid;
  }

  onStationDetailsChange(station:IStationDetails, isValid:boolean) {
    this.isStepOneValid = isValid;
    this.stationDetails = station;
  }

  onHistoricalDataChange(dataFile:File, isValid:boolean) {
    this.isStepThreeValid = isValid;
    this.historicalDataFile = dataFile;
  }

  onSnowDataChange(dataFile:File, isValid:boolean) {
    this.isStepFourValid = isValid;
    this.snowDataFile = dataFile;
  }

  onStationAggregationsChange(selectedStations: IAggregationsData[], isValid:boolean) {
    this.isStepTwoValid = isValid;
    this.stationDetails.aggregations = selectedStations;
  }

  nextStep() {
    this.selectedTabIndex += 1;
  }

  prevStep() {
    this.selectedTabIndex -= 1;
  }

  createStation() {
    this.isLoading = true;
    const stationRequest:IStationDetailsRequest = {
      siteName: this.stationDetails.name,
      siteCode: this.stationDetails.code,
      country: this.stationDetails.country,
      basin: this.stationDetails.basin,
      region: this.stationDetails.region,
      latitude: this.stationDetails.location.latitude,
      longitude: this.stationDetails.location.longitude,
      aggregations: this.stationDetails.aggregations,
      isVirtual: this.isVirtual
    };
    this.stationApi.createDischargeStation(stationRequest,
        this.dischargeModel,
        this.historicalDataFile,
        this.stationDetails.maxDischarge)
        .then((station) => {

          let confirm = this.$mdDialog.confirm()
              .title(this.$translate.instant('FORECAST_MODEL_SETUP'))
              .textContent(this.$translate.instant('FORECAST_MODEL_SETUP_EXTENDED'))
              //.targetEvent($event)
              .ok(this.$translate.instant('OK'))
              .cancel(this.$translate.instant('CANCEL'));

          
          if (!station.isVirtual && this.snowDataFile) {
            this.Upload.base64DataUrl(this.snowDataFile)
              .then((jsonstring) => {
                
                  this.stationApi.uploadSnowData(station.id, jsonstring)
                    .then(() => {
                      this.$mdDialog.show(confirm).then(() => {
                        this.$state.go('station.forecastModels', {stationId: station.id});
                      }, () => {
                        this.$state.go('station.manager');
                      })
                      
                    })
                    .catch((error: any) => {
                      this.imomoErrorService.showErrorDetailsDialog(error.data.details)
                    })
                    .finally(() => {
                      this.isLoading = false;
                    });
                
              });
            } else {
              this.$mdDialog.show(confirm).then(() => {
                this.$state.go('station.forecastModels', {stationId: station.id});
              }, () => {
                this.$state.go('station.manager');
              })
            }
        })
        .catch((error:any) => {
          this.imomoErrorService.showErrorDetailsDialog(error.data.details)
        })
        .finally(() => {
          this.isLoading = false;
        });
  }
}



/** WEBPACK FOOTER **
 ** ./app/station/creator/creator.controller.ts
 **/